import z from "zod";
import {
  PrepStationIdScheme,
  BookkeepingAccountIdScheme,
  CourseIdScheme,
  ModifierIdScheme,
  ProductGroupIdScheme,
  ProductIdScheme,
  ProductVariantIdScheme,
  ReceiptItemIdScheme,
  ServiceOrderIdScheme,
  SupplierIdScheme,
} from "./ids";
import { MoneyScheme } from "./money";
import { DiscountScheme } from "./discount";
import { AppliedOfferScheme } from "./offer";
import { ProductType } from "./enums/ProductType";

export const CartItemDBScheme = z.object({
  id: ReceiptItemIdScheme,
  productId: ProductIdScheme,
  quantity: z.number(),
  sizeOfItem: z.number(),
  unitPrice: MoneyScheme,
  VAT: z.number(),
  name: z.string(),
  variantName: z.string().optional(),
  type: z.enum(ProductType),
  unit: z
    .object({
      name: z.string(),
      suffix: z.string(),
      decimals: z.number(),
    })
    .nullable(),
  prepStationId: PrepStationIdScheme.optional().nullable(),
  courseId: CourseIdScheme.optional().nullable(),
  bookkeepingAccountId: BookkeepingAccountIdScheme.nullable(),
  bookkeepingCostcenter: z.string().optional(),
  discount: DiscountScheme.nullable(),
  description: z.string().nullable(),
  groupId: ProductGroupIdScheme.nullable(),
  supplierId: SupplierIdScheme.optional().nullable(),
  articleNumber: z.string().nullable(),
  modifiers: z
    .array(
      z.object({
        modifierId: ModifierIdScheme,
        name: z.string(),
        unitPrice: MoneyScheme,
        VAT: z.number(),
        bookkeepingAccountId: BookkeepingAccountIdScheme.nullable(),
        internal: z.boolean().optional(),
        removed: z.boolean().optional(),
        quantity: z.number().optional(),
      }),
    )
    .optional(),
  variantId: ProductVariantIdScheme.optional().nullable(),
  receiptNote: z.string().optional().nullable(),
  internalNote: z.string().optional().nullable(),
  extraFields: z
    .array(
      z.object({
        key: z.string(),
        value: z.string(),
        name: z.string(),
      }),
    )
    .optional()
    .nullable(),
  parts: z.number().optional().nullable(),
  isTakeaway: z.boolean().optional().nullable(),
  image: z.string().optional().nullable(),
  noPrepTicket: z.boolean().optional().nullable(),
  skipStock: z.boolean().optional(),
  noDiscount: z.boolean().optional(),
  appliedOffer: AppliedOfferScheme.optional().nullable(),
  serviceOrderId: ServiceOrderIdScheme.optional().nullable(),
  serialNumbers: z.array(z.string()).optional(),
});

export const RestGetCartItem = CartItemDBScheme;

export const RestCreateCartItem = CartItemDBScheme.omit({ id: true });
export const RestUpdateCartItem = CartItemDBScheme.omit({ id: true }).partial();

export type DBCartItem = z.infer<typeof CartItemDBScheme>;
export type RestCartItem = z.infer<typeof RestGetCartItem>;
export type RestCreateCartItem = z.infer<typeof RestCreateCartItem>;
export type RestUpdateCartItem = z.infer<typeof RestUpdateCartItem>;
